var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:['flex items-center gap-2 text-sm leading-none font-medium select-none', _vm.className],attrs:{"for":_vm.forId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }